import { BaseService } from './base.service'

import axios from '@axios'
import { ResponseWrapper, ErrorWrapper } from './util'

export class AnnouncementService extends BaseService {
  static get entity () {
    return '/employee-activity/announcement'
  }

  static async create (data = {}) {
    try {
      const response = await axios.post(`${this.entity}`, data, {
        headers: { "content-type": "multipart/form-data" },
      })
      
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data = {}) {
    
    try {
      const response = await axios.put(`${this.entity}/${id}`, data, {
        headers: { "content-type": "multipart/form-data" },
      })

      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}